import { useContext } from 'react';
import { IbkContext } from '@/providers/IbkProvider';
import type { IbkContextType } from '@/providers/IbkProvider';

export default function useIbkAvailability(): IbkContextType {
  const ibkAvailability = useContext<IbkContextType>(IbkContext);
  return ibkAvailability;
}
